import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_31712_5820",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			fill: "#000000",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "#d9d9d9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_31712_5820)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8.41047 2.04398C8.30902 2.00028 8.19747 1.98882 8.08981 2.01106C7.98215 2.0333 7.88318 2.08823 7.8053 2.16898L1.16282 7.61898C1.11117 7.67277 1.07019 7.73667 1.04223 7.80703C1.01427 7.87738 0.999878 7.95281 0.999878 8.02898C0.999878 8.10516 1.01427 8.18058 1.04223 8.25094C1.07019 8.32129 1.11117 8.3852 1.16282 8.43898L7.8053 13.86C7.8565 13.9141 7.91748 13.9571 7.9847 13.9865C8.05193 14.0158 8.12407 14.031 8.19694 14.031C8.27013 14.0305 8.34258 14.0156 8.41047 13.987C8.51076 13.9425 8.596 13.8677 8.65521 13.7721C8.71443 13.6766 8.74491 13.5648 8.74273 13.451V10.205C15.8487 10.205 18.953 12.297 18.48 18.96C21.4886 8.29898 15.7127 5.88898 8.74178 5.88898V2.57898C8.74397 2.46546 8.71359 2.35386 8.65455 2.25851C8.59551 2.16317 8.5105 2.08846 8.41047 2.04398Z",
				fill: "#c1c9e0"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgUndo);
export default ForwardRef;
